import { Link, useLocation } from 'react-router-dom';
import { useUserRole } from '../auth/AdminRoute';

interface HeaderProps {
  showBackButton?: boolean;
  backHref?: string;
  title?: string;
}

export function Header({
  showBackButton,
  backHref = '/',
  title,
}: HeaderProps) {
  const location = useLocation();
  const { role } = useUserRole();

  // Show admin link for any user with a role (both admin and ship-request can access /admin)
  const isAuthenticatedPage = location.pathname !== '/';
  const isAdmin = isAuthenticatedPage && role !== null;

  return (
    <header className="w-full py-6 overflow-x-hidden">
      <div className="w-full max-w-6xl mx-auto px-4 box-border">
        <div className="relative flex items-center justify-center min-h-[2.5rem]">
          {/* Left: back button when present */}
          <div className="absolute left-0 top-1/2 -translate-y-1/2">
            {showBackButton && (
              <Link
                to={backHref}
                className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
                <span>Back</span>
              </Link>
            )}
          </div>

          {/* Center: logo */}
          <Link to="/" className="flex items-center justify-center">
            <img
              src="/images/Star-Logo-Featured-Image-2.webp"
              alt="Star Micronics"
              className="h-10 w-auto"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
          </Link>

          {/* Right: Reports link (admin only) or title */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2">
            {isAdmin && (
              <Link
                to="/admin"
                className={`text-sm font-medium px-3 py-1.5 rounded-lg transition-colors ${
                  location.pathname === '/admin'
                    ? 'bg-primary/10 text-primary'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                Reports
              </Link>
            )}
            {title && !showBackButton && !isAdmin && (
              <h1 className="text-lg font-medium text-gray-900">{title}</h1>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
